import { useEffect } from 'react';
import { GraduationCap } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import { LoadingState, ErrorState } from '../../components/LoadingState';
import { useGenerateObjectives } from '../../api/queries';
import styles from './GoalsView.module.css';

export function GoalsView() {
  const mut = useGenerateObjectives();
  useEffect(() => {
    if (!mut.data && !mut.isPending && !mut.error) mut.mutate({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (mut.isPending) return <LoadingState label="Identificando objetivos de aprendizaje…" />;
  if (mut.error) return <ErrorState error={mut.error} onRetry={() => mut.mutate({})} />;
  const data = mut.data as any;
  if (!data) return null;

  const general: string = data.content?.unit_objectives?.general_objective ?? '';
  const specifics = data.content?.unit_objectives?.specific_objectives ?? [];

  const groups: Array<{ label: string; list: string[] }> = [];
  if (Array.isArray(specifics)) {
    for (const s of specifics) {
      if (s?.cognitive) groups.push({ label: 'Conocimientos', list: s.cognitive });
      if (s?.procedural) groups.push({ label: 'Habilidades', list: s.procedural });
      if (s?.attitudinal) groups.push({ label: 'Actitudes', list: s.attitudinal });
    }
  }

  return (
    <div className={styles.view}>
      {general && (
        <section className={styles.general}>
          <div className={styles.generalIcon} aria-hidden>
            <GraduationCap size={18} />
          </div>
          <div>
            <h3 className={styles.generalLabel}>Objetivo general</h3>
            <div className={styles.generalText}>
              <ReactMarkdown>{general}</ReactMarkdown>
            </div>
          </div>
        </section>
      )}

      {groups.map((g, idx) => (
        <section key={idx} className={styles.group}>
          <h3 className={styles.groupLabel}>{g.label}</h3>
          <ul className={styles.list}>
            {g.list.map((item, i) => (
              <li key={i} className={styles.item}>
                <span className={styles.bullet} aria-hidden />
                <span className={styles.text}>
                  <ReactMarkdown>{item}</ReactMarkdown>
                </span>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
